import { FirebaseServices } from "./config";
import { callFunction } from "./helpers";
import { trackMemoryAdded } from "../analytics";
import { entityCache } from "../sync/entity-cache";
import {
  CreateMemoryRequest,
  CreateMemoryResponse,
  EditMemoryRequest,
  DeleteMemoryRequest,
  GetMemoryRequest,
  GetMemoryResponse,
  GetMyMemoriesRequest,
  GetMyMemoriesResponse,
  StandardResponse,
  GetAllMemoriesRequest,
  GetAllMemoriesResponse,
} from "common247";

export async function createMemory(fb: FirebaseServices, request: CreateMemoryRequest): Promise<CreateMemoryResponse> {
  const result = (await callFunction(fb, "createMemoryFunc", request)) as CreateMemoryResponse;
  if (result && (result as any).status !== false) {
    trackMemoryAdded(
      (result as any).id || (result as any).memoryId || "created_memory",
      request.mediaIds ? request.mediaIds.length : 0,
      request.title ? request.title.length : 0
    );
  }
  return result;
}

export async function editMemory(fb: FirebaseServices, request: EditMemoryRequest): Promise<StandardResponse> {
  const result = await callFunction(fb, "editMemoryFunc", request);
  return result as StandardResponse;
}

export async function getMemory(fb: FirebaseServices, request: GetMemoryRequest): Promise<GetMemoryResponse> {
  const result = await callFunction(fb, "getMemoryFunc", request);
  return result as GetMemoryResponse;
}

export async function getMyMemories(fb: FirebaseServices, request: GetMyMemoriesRequest): Promise<GetMyMemoriesResponse> {
  const result = (await callFunction(fb, "getMyMemoriesFunc", request)) as GetMyMemoriesResponse;
  if (result && Array.isArray(result.memories)) {
    entityCache.setCachedList("memory", result.memories, "myMemories");
  }
  return result;
}

export async function deleteMemory(fb: FirebaseServices, request: DeleteMemoryRequest): Promise<StandardResponse> {
  const result = await callFunction(fb, "deleteMemoryFunc", request);
  return result as StandardResponse;
}

export async function getAllMemories(fb: FirebaseServices, request: GetAllMemoriesRequest): Promise<GetAllMemoriesResponse> {
  const result = await callFunction(fb, "getAllMemoriesFunc", request);
  return result as GetAllMemoriesResponse;
}
